import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
// import { v4 } from "uuid";
// import CryptoJS, { AES } from "crypto-js";
import {
  Grid,
  Box,
  // MuiGrid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
  Button,
  IconButton,

  // Divider,
} from "@mui/material";
// import classNames from "classnames";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import SnackbarMessage from "components/modal/SnackbarMessage";
// import ModalContractQrFile from "components/modal/ModalContractQrFile";
import client from "assets/js/commonApi";

// import { styled } from "@mui/material/styles";
import ModalFileExplorer from "components/modal/ModalFileExplorer";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";

// const MAX_FILE_SIZE = 8 * 1024 * 1024; // 8MB

function BtnNDragUploadFile({
  label = "",
  className = "",
  onFileSelect = () => null,
  group,
  files,
  fileExt,
  contract_sub_id,
  did,
  onChange,
  upLoadCid,
  // fileNames,
  fileNameData,
  encryptKey,
  // handleQrClose,
  handleQrUploadClose,
  accept,

  // props,

  // limitInterval,
  // limit,
  // props,
}) {
  //
  // 파일 기능
  // // limitInterval 필요하다면 사용하지만, 필요하지않아, 그냥 생략 해도 됨
  // const { limitInterval } = props;

  // const access = sessionStorage.getItem("access");
  // const refresh = sessionStorage.getItem("refresh");
  const [fileData, setFileData] = useState([]);

  // const fileInputRef = useRef(null);
  const [uploadFile, setUploadFile] = useState(null);

  // 파일 사이즈 제한
  // const MAX_FILE_SIZE = 8 * 1024 * 1024; // 8MB

  // const [open, setOpen] = React.useState(false);

  // upLoad Cid

  // const [cidData, setCidData] = useState();
  // const [fileNameDp, setFileNameDp] = useState();
  // const [enckey, setEnckey] = useState();

  // useEffect(() => {
  // if () {
  // console.log("upLoadCid", upLoadCid);
  // console.log("[[key]]", encryptKey)
  // }
  // }, []);

  const [showFileExplorer, setShowFileExplorer] = useState(false);
  // const [fileNameInfo, setFileNameInfo] = useState();
  // console.log("fileNameInfo", fileNameInfo);

  // 파일 데이터 가져오기
  useEffect(() => {
    // axios
    //   .post(
    //     "http://ariescontrol.busan-coldchain.com:8079/mdpt_file/file_name_select",
    //     {
    //       contract_sub_id: contract_sub_id,
    //     },
    //   )
    //   .then((res) => {
    //     if (res.data?.data) {
    //       console.log("777777777res", res);
    //       console.log("777777777res이름", res.data.data.NAME);
    //       setFileNameInfo(res);
    //       setFileNameDp(res.data.data.NAME);
    //     }
    //   });
    // const fileNameInfo
  }, []);

  useEffect(() => {
    console.log("로드 파일 데이터", files);
    if (files) {
      setFileData(files);
    }
  }, [files]);

  useEffect(() => {
    onChange && onChange(fileData);
  }, [onChange, fileData]);

  // const handleClick = () => {
  //   setOpen(true);
  // };

  // const handleClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpen(false);
  // };

  // const handleOnlyQrFileClose = () => {
  //   setIsOpenFileQrModal(false);
  // };

  // 파일업로드 QR 상태 값
  // QR 버튼
  // const [QrBtn, setQrBtn] = useState();
  // QR 창
  // const [isOpenFileQrModal, setIsOpenFileQrModal] = useState(false);
  // const handleClickQrOpen = (params) => {
  //   console.log("777params", params);
  //   console.log("handleClickQrOpen", handleClickQrOpen);
  //   // alert("handleClickQrOpen");
  //   setIsOpenFileQrModal(true);
  //   setQrBtn(params.target.value);
  // };
  // const FileQrButton = ({ fileData }) => {
  //   if (fileData.status === 200) {
  //     return (
  //       <Button
  //         autoFocus
  //         value={QrBtn}
  //         onClick={handleClickQrOpen}
  //         variant="contained"
  //         sx={{ background: "#468ECD", display: "flex", width: "100%" }}
  //       >
  //         업로드 파일 QR 전송
  //       </Button>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  // const OnFileChangeMessage = ({ fileData }) => {
  //   console.log("fileData", fileData);
  //   // alert(fileData.data.Size);
  //   if (fileData.status === 200) {
  //     // alert(fileData.Size);
  //     return (
  //       <>
  //         {/* <fileQrButton /> */}
  //         <SnackbarMessage
  //           // onChange={onFileChange}
  //           open={open}
  //           handleClose={handleClose}
  //           message="파일 업로드 되었습니다."
  //         />
  //       </>
  //     );
  //   }
  // };

  // const StyledPaper = styled(Paper)(({ theme }) => ({
  //   // StyledPaper 컴포넌트
  //   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  //   ...theme.typography.body2,
  //   padding: theme.spacing(2),
  //   margin: "8px auto",
  //   display: "flex",
  //   flex: 1,
  //   color: theme.palette.text.primary,
  // }));

  // 내보낸다
  const FileDisplay = ({ fileData }) => {
    if (fileData && fileData.length > 0) {
      return (
        <Grid item xs container direction="column">
          <Grid
            container
            wrap="nowrap"
            sx={{
              mt: 1,
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderRadius: 1,
              }}
            >
              {fileData?.map((f, index) => (
                <Box
                  key={f.upload_file_id}
                  alignItems={"center"}
                  sx={{ display: "flex", flexDirection: "row" }}
                >
                  <FileUploadIcon
                    style={{
                      fontSize: 26,
                      color: "#468ECD",
                    }}
                  />
                  <Typography
                    key={f.upload_file_id}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      textDecoration: "underline",
                      color: "#468ECD",
                    }}
                  >
                    {f.file_ext
                      ? `${f.file_name}.${f.file_ext}`
                      : f.file_name || `파일 ${index + 1}`}
                  </Typography>
                  <IconButton
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setFileData((pre) =>
                        pre.filter(
                          (item) => item.upload_file_id !== f.upload_file_id,
                        ),
                      );
                    }}
                  >
                    <CloseIcon
                      style={{
                        fontSize: 26,
                        color: "#468ECD",
                      }}
                    />
                  </IconButton>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Typography component="h2" variant="subtitle2" sx={{ color: "#ccc" }}>
          이 곳을 클릭하여 계약 파일을 선택하세요
        </Typography>
      );
    }
  };

  const [_group, setGroup] = useState();
  useEffect(() => {
    console.debug("[useEffect]", group);
    if (group) {
      client.post("/group/list", {}).then((res) => {
        const _ = res?.data?.data;
        const data = _.filter((item) => item.group_id === group);

        if (data && data.length > 0) {
          setGroup(data[0]);
        }
      });
    }
  }, [group]);

  return (
    <div style={{ flex: 1 }}>
      {label && label !== "" && <label htmlFor={label}>{label ?? ""}</label>}
      <Box
        sx={{
          flexDirection: "column",
          display: "flex",
          marginBottom: "12px",
        }}
      >
        <Button
          type="button"
          variant="text"
          // className="body-regular border-natural-5 text-character-primary flex flex-row items-center justify-center gap-[10px] whitespace-nowrap border-[1px] border-solid px-[15px] py-[4px]"
          component="label"
          // startIcon={
          //   <CloudUploadIcon fontSize="large" sx={{ color: "#468ECD" }} />
          // }
          // sx={{ background: "#468ECD" }}
          fileName={uploadFile?.name}
          onClick={(event) => {
            event.preventDefault();
            // event.stopPropagation();
            setShowFileExplorer(true);

            // fileInputRef.current?.click();
          }}
        >
          <Box sx={{ alignContent: "center", textAlign: "center" }}>
            <CloudUploadIcon fontSize="large" sx={{ color: "#468ECD" }} />
            <FileDisplay
              fileData={fileData}
              // fileNameData={fileNameData || fileNameDp}
            />
            {/* <Typography
              component="h2"
              variant="subtitle2"
              sx={{ color: "#ccc" }}
            >
              Drag 'n' drop some files here, or click to select files
            </Typography>
            <Typography
              component="h2"
              variant="subtitle2"
              sx={{ color: "#000" }}
            >
              현재 업로드 된 파일 : {fileNameData}
            </Typography> */}
          </Box>
        </Button>
        {/* <input
          id={label}
          type="file"
          // accept=".json,.csv,.excel,.txt,.XML,.zip,.pdf"
          accept={accept}
          className="hidden"
          // style={{ border: "0" }}
          // style={{ display: "none" }}
          multiple={false}
          ref={fileInputRef}
          onChange={onFileChange}
          // onClick={handleClick}
          // onClick={}
          // onChange={(e) => {
          //   try {
          //     const file = e.target.files;
          //     if (file) {
          //       if (file[0].size <= MAX_FILE_SIZE) {
          //         setUploadFile(file[0]);
          //       } else {
          //         throw "파일 사이즈는 8MB 이하로 첨부 가능합니다.";
          //       }
          //     } else {
          //     }
          //   } catch (e) {
          //     // 에러 구간
          //   }
          // }}
        /> */}
      </Box>
      {/* <OnFileChangeMessage fileData={fileData} />
      <FileQrButton fileData={fileData} /> */}
      <ModalFileExplorer
        group={_group}
        fileData={fileData}
        fileExt={fileExt}
        isOpen={showFileExplorer}
        onSelect={(files) => {
          setFileData(files);
          // if (files && files.length > 0) {
          //   // const { file_name, file_ext } = files[0];
          //   // setFileNameDp(`${file_name}.${file_ext}`);
          //   console.log("[매핑파일]", files[0]);
          // }
        }}
        onClose={() => setShowFileExplorer(false)}
      />
      {/* <FileUploadMessage /> */}
      {/* {isOpenFileQrModal ? (
        <ModalContractQrFile
          // onClose={handleQrClose}
          isOpen={isOpenFileQrModal}
          // handleClose={handleQrClose}
          handleClose={handleQrUploadClose}
          // handleClose={handleClose}
          handleOnlyQrFileClose={handleOnlyQrFileClose}
          // value={contract_sub_id}
          cid={cidData}
          contract_sub_id={contract_sub_id}
          encryptKey={encryptKey}
          // limit={limit}
          // limitInterval={limitInterval}
          // limit={limit}
          // limitInterval={limitInterval}
          // props={props}
          // did={selectDid}
          // contract_sub_id={selectContractNumber}
          // open={isOpenModal}
          // onClose={handleQrClose}
        />
      ) : null} */}
    </div>
  );
}

export default BtnNDragUploadFile;
